export default "__VITE_ASSET__C2zyQ0CR__"